const createDefaultState = () => ({
  formData: {
    keyword: '',
    date: [],
    titleKw: '',
    contentKw: '',
    ay: '',
    ajlx: '',
    fyjb: '',
    issuingDepartment: '',
    publishYear: '',
    effectiveYear: ''
  },
  type: 'wlzl', // wlzl-网络资料，ft-法条；al-案例；mbgz-模板规则；zcwj-政策文件；xmjx-熊猫精选；zsk-我的知识库
  total: 0, // 检索数据总数
  wlzlList: [], // 查询出来的网络资料数据
  ftList: [], // 法条
  alList: [], // 案例
  mbgzList: [], // 模板规则
  zcwjList: [], // 政策文件
  xmjxList: [], // 熊猫精选
  zskList: [], // 知识库
  wlzlKw: '', // 搜索要求
  ftKw: '',
  alKw: '',
  mbgzKw: '',
  zcwjKw: '',
  xmjxKw: '',
  zskKw: '',
  hideRight: false // 是否收起右边指令舱
})

const assignMutation = (key) => (state, payload) => {
  state[key] = payload
}

const mutations = {
  SEARCH_CHANGE_FORMDATA: assignMutation('formData'),
  SEARCH_CHANGE_TYPE: assignMutation('type'),
  RESULT_TOTAL: assignMutation('total'),
  RESULT_WLZL_LIST: assignMutation('wlzlList'),
  RESULT_FT_LIST: assignMutation('ftList'),
  RESULT_AL_LIST: assignMutation('alList'),
  RESULT_MBGZ_LIST: assignMutation('mbgzList'),
  RESULT_ZCWJ_LIST: assignMutation('zcwjList'),
  RESULT_XMJX_LIST: assignMutation('xmjxList'),
  RESULT_ZSK_LIST: assignMutation('zskList'),
  KEYWORD_WLZL: assignMutation('wlzlKw'),
  KEYWORD_FT: assignMutation('ftKw'),
  KEYWORD_AL: assignMutation('alKw'),
  KEYWORD_MBGZ: assignMutation('mbgzKw'),
  KEYWORD_ZCWJ: assignMutation('zcwjKw'),
  KEYWORD_XMJX: assignMutation('xmjxKw'),
  KEYWORD_ZSK: assignMutation('zskKw'),
  HIDE_RIGHT: assignMutation('hideRight')
}
const actions = {}
export default {
  namespaced: true,
  state: createDefaultState,
//   getters,
  mutations,
  actions
}